import { render } from "./PostToAccount.vue?vue&type=template&id=f1fe8b32&scoped=true"
import script from "./PostToAccount.vue?vue&type=script&lang=js"
export * from "./PostToAccount.vue?vue&type=script&lang=js"

import "./PostToAccount.vue?vue&type=style&index=0&id=f1fe8b32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1fe8b32"]])

export default __exports__